import { AccountMappingAccountItem, IReclassesAccounts } from '@modeso/types__aumico-lib-annualreport-be';

export interface IMappingAndReclassesAccounts {
    mappedAccounts: AccountMappingAccountItem[];
    reclassesAccounts: IReclassesAccounts[];
}
